import Grid from '@material-ui/core/Grid/Grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { transactionSearchModalStyles } from '../transaction-based-return-styles';

export const SearchResultsCategoryHead = (): JSX.Element => {
  const classes = transactionSearchModalStyles();
  const { t } = useTranslation();
  return (
    <Grid container item justifyContent='flex-start' className={classes.outerContainerStyle}>
      <Grid item>
        <Grid container item>
          <Grid
            item
            className={`${classes.categoryHeadStyle} ${classes.datePadding} ${classes.returnItemTitleSubheader}`}
          >
            {t('SearchResultsDataGrid_DateColumn')}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item>
          <Grid
            item
            className={`${classes.categoryHeadStyle} ${classes.timePadding} ${classes.returnItemTitleSubheader}`}
          >
            {t('SearchResultsDataGrid_TimeColumn')}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item>
          <Grid
            item
            className={`${classes.categoryHeadStyle} ${classes.txnPadding} ${classes.returnItemTitleSubheader}`}
          >
            {t('TBR_Transaction_Category_Head')}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item>
          <Grid
            item
            className={`${classes.categoryHeadStyle} ${classes.posPadding} ${classes.returnItemTitleSubheader}`}
          >
            {t('SearchResultsDataGrid_TouchIdColumn')}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item>
          <Grid
            item
            className={`${classes.categoryHeadStyle} ${classes.storePadding} ${classes.returnItemTitleSubheader}`}
          >
            {t('SearchResultsDataGrid_StoreIdColumn')}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item>
          <Grid
            item
            className={`${classes.categoryHeadStyle} ${classes.valuePadding} ${classes.returnItemTitleSubheader}`}
          >
            {t('SearchResultsDataGrid_TotalColumn')}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
